<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-heading">
      <h5>
        {{ project.attributes.name }} &middot; {{ project.attributes.project_category_name }}
      </h5>
    </div>

    <div
        class="panel-body"
        :class="{'project-description-limited': collapsed}"
    >
      <div v-html="project.attributes.description"/>

      <div class="project-description-show-more" :class="{'project-description-show-more--collapsed': collapsed}">
        <button type="button" class="btn btn-xs btn-black" @click="collapsed = !collapsed">
          <i class="fa fa-search"/> {{ collapsed ? 'Expand' : 'Collapse'}}
        </button>
      </div>
    </div>
  </div>
</template>

<style>
.project-description-limited {
  height: 100px;
  overflow: hidden;
  position: relative;
}

.project-description-show-more {
  text-align: right;
  width: 100%;
}

.project-description-show-more--collapsed {
  background-image: linear-gradient(to bottom, transparent, white);
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 20px;
}
</style>

<script>
export default {
  props: {
    project: {
      required: true
    }
  },

  data(){
    return{
      collapsed: true
    }
  }
}
</script>